import { css } from 'styled-components';

export const SelectContainer = css`
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.35;
    `};
`;

export const Control = css`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  width: 100%;
  height: 67px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.background};
  outline: none;
  transition: 0.2s all;
  box-sizing: border-box;

  ${(props) =>
    props.invalid &&
    css`
      border: 1px solid ${(props) => props.theme.borderColorOnInvalid};
    `}

  ${(props) =>
    props.valid &&
    css`
      border: 1px solid ${(props) => props.theme.borderColorOnValid};
    `}

    ${(props) =>
    props.small &&
    css`
      height: 50px;
    `}
`;

export const ValueContainer = css`
  align-items: center;
  display: flex;
  height: 100%;
  flex: 1;
  flex-wrap: wrap;
  padding: 0;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
`;

export const Placeholder = css`
  display: flex;
  position: absolute;
  top: 50%;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.color};
  transition: 0.2s all;
  transform: translateY(-50%);
  font-size: 21px;
  font-weight: 500;
  box-sizing: border-box;

  ${(props) =>
    props.small &&
    css`
      font-size: 20px;
    `}
`;

export const SingleValue = css`
  display: flex;
  position: absolute;
  top: 50%;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.color};
  transition: 0.2s all;
  transform: translateY(-50%);
  font-size: 21px;
  font-weight: 500;
  box-sizing: border-box;

  ${(props) =>
    props.invalid &&
    css`
      color: ${(props) => props.theme.colorOnInvalid};
    `}

  ${(props) =>
    props.small &&
    css`
      font-size: 20px;
    `}
`;

export const Input = css`
  display: flex;
  position: absolute;
  top: 50%;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.color};
  transition: 0.2s all;
  transform: translateY(-50%);
  font-size: 21px;
  font-weight: 500;
  box-sizing: border-box;

  ${(props) =>
    props.invalid &&
    css`
      color: ${(props) => props.theme.colorOnInvalid};
    `}

  ${(props) =>
    props.small &&
    css`
      font-size: 20px;
    `}
`;

export const Menu = css`
  position: absolute;
  top: 100%;
  width: 100%;
  border: 0;
  margin-top: 0px;
  z-index: 100;
`;

export const MenuList = css`
  position: relative;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.background};
  transition: 0.2s all;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Option = css`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: 67px;
  padding: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
  color: ${(props) => props.theme.color};
  transition: 0.2s all;
  font-size: 21px;
  font-weight: 500;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.backgroundOnHover};
  }

  ${(props) =>
    props.small &&
    css`
      min-height: 50px;
      font-size: 20px;
    `}

  ${(props) =>
    props.selected &&
    css`
      background: ${(props) => props.theme.backgroundOnSelect};
      font-weight: 500;
    `}
`;

export const IndicatorSeparator = css``;

export const IndicatorsContainer = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 67px;
  height: 67px;
  transition: 0.2s all;
  box-sizing: border-box;
  cursor: pointer;

  ${(props) =>
    props.small &&
    css`
      width: 50px;
      height: 50px;
    `}
`;

export const NoOptionsMessage = css`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: 67px;
  padding: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
  color: ${(props) => props.theme.color};
  transition: 0.2s all;
  font-size: 21px;
  font-weight: 500;
  box-sizing: border-box;
  cursor: pointer;

  ${(props) =>
    props.small &&
    css`
      min-height: 50px;
      font-size: 20px;
    `}
`;

export const DropdownIndicator = css`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s all;
  width: 67px;
  height: 67px;
  font-size: 24px;

  ${(props) =>
    props.small &&
    css`
      width: 50px;
      height: 50px;
    `}
`;

export const DropdownIndicatorIcon = css`
  display: inline-block !important;
  width: auto !important;
  margin: auto !important;
  color: ${(props) => props.theme.color};
  transform: scaleY(1);
  transition: 0.2s all;
  user-select: none;
  font-size: 36px;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }

  ${(props) =>
    props.small &&
    css`
      font-size: 32px;
    `}
`;

export const MultiValueContainer = css`
  display: flex;
  position: absolute;
  top: 50%;
  left: 0;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  color: ${(props) => props.theme.color};
  transition: 0.2s all;
  transform: translateY(-50%);
  font-size: 21px;
  font-weight: 500;
  box-sizing: border-box;
`;

export const MultiValueLabel = css`
  display: inline;
  padding: 0 0 0 13px;
`;

export const Checkbox = css`
  position: relative;
  display: block;
  height: 18px;
  width: 18px;
  flex-shrink: 0;
  margin: 0 12px 0 0;
  border: 2px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  border-radius: 4px;
  outline: none;
  transition: 0.2s all;
  cursor: pointer;

  ${(props) =>
    props.visible &&
    css`
      border: 2px solid ${(props) => props.theme.borderOnCheckmark};
      background: ${(props) => props.theme.backgroundOnCheckmark};
    `}
`;

export const CheckboxInput = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  opacity: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
`;

export const CheckboxCheckmark = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  transition: 0.2s all;
  opacity: 0;
  font-size: 1.6rem;
  cursor: pointer;

  ${(props) =>
    props.visible &&
    css`
      opacity: 1;
      color: ${(props) => props.theme.colorOnCheckmark};
    `}
`;

export const Radio = css`
  position: relative;
  display: block;
  height: 18px;
  width: 18px;
  flex-shrink: 0;
  margin: 0 12px 0 0;
  border: 2px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  border-radius: 100%;
  outline: none;
  transition: 0.2s all;
  cursor: pointer;

  ${(props) =>
    props.visible &&
    css`
      border: 2px solid ${(props) => props.theme.borderOnCheckmark};
      background: ${(props) => props.theme.backgroundOnCheckmark};
    `}
`;

export const RadioInput = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  opacity: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
`;

export const RadioCheckmark = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  transition: 0.2s all;
  opacity: 0;
  font-size: 1.6rem;
  cursor: pointer;

  ${(props) =>
    props.visible &&
    css`
      opacity: 1;
      color: ${(props) => props.theme.colorOnCheckmark};
    `}
`;
